/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Trigger_TypeInputs */

const cs_field_trigger_type = /** @type {(inputs: Field_Trigger_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ spouštěče`)
};

const en_field_trigger_type = /** @type {(inputs: Field_Trigger_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger type`)
};

/**
* | output |
* | --- |
* | "Trigger type" |
*
* @param {Field_Trigger_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_trigger_type = /** @type {((inputs?: Field_Trigger_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Trigger_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_trigger_type(inputs)
	return cs_field_trigger_type(inputs)
});